import { Badge } from './Badge';

export const BetaBadge = () => {
  return (
    <Badge bold color="primary" rounded uppercase>
      Beta
    </Badge>
  );
};
